// Start of prototype notify
// --------------------
// jnotification (http://demos.9lessons.info/jnotification/)
// @author: Han Speerstra

/**
 * Notify based on jQuery Notification
 * @param  {varchar} 	$msg            text to show
 * @param  {varchar} 	$type           error/warning/success
 * @param  {varchar} 	$icon_override  if icon is applied, override it
 * @param  {int} 		$timeout        the time the notification is shown after it will be hidden, default = 5
 * @param  {int} 		$timebeforeshow the time before the notification as to be shown
 * @return {void}
 */
export default function notify($msg, $type, $icon_override, $timeout, $timebeforeshow)
{
	if( ! $timebeforeshow > 0) {
		$timebeforeshow = 0;
	}
	if( ! $timeout) {
		$timeout = 5;
	}

    showNotification({
	    message: $msg,
	    autoClose: true,
	    duration: $timeout,
	    startAfter: $timebeforeshow,
	    type: $type
	});
    // });
}

/**
 * Reload page and notify
 * @param  {varchar} message text to show
 * @param  {varchar} type    error/warning/success
 * @param  {varchar} url     custom url when redirect is required
 * @return {void}
 */
export function notify_reload(message, type, url)
{
    if(url == null) url = document.location.href;

    // Haal de token op uit de meta-tag (die staat standaard in je Master Blade)
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const appUrl = window.Laravel.url;

    const form = $(`
        <form action="${appUrl}/notify" method="POST" style="display:none;">
            <input type="hidden" name="_token" value="${csrfToken}">
            <input type="hidden" name="url" value="${url}">
            <input type="hidden" name="notify" value="${message}">
            <input type="hidden" name="type" value="${type}">
        </form>
    `);

    form.appendTo('body').submit();
}
